"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap gap-6 justify-center">
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="h-4 w-16 bg-muted-light/30 animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex flex-wrap gap-6 justify-center">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-sm text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] hover:underline decoration-accent decoration-2 underline-offset-4">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <footer id="footer" ref={ref} className={`bg-dark-background py-12 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {}
          <div className="text-center md:text-left">
            <p className="text-sm text-foreground-dark/80">
              © {new Date().getFullYear()} Glass House Properties. All rights reserved.
            </p>
          </div>

          {}
          <MenuProvider menu_id="34">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex gap-4 justify-center md:justify-end">
            <Link to="#" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-fast)] hover:scale-[1.08]" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="#" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-fast)] hover:scale-[1.08]" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="#" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-fast)] hover:scale-[1.08]" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}